import { createSelector } from 'reselect'
import { getInstitutionOptions } from '../../reducers/InstitutionOptionsReducer/actions'

export const institutionOptionAsTree = createSelector(
  state => getInstitutionOptions(state),
  options => {
    const optionsTree = {}

    for (const option of options) {
      const body = {
        optionId: option.id,
        institution: option.institution.id,
        optionEnabled: option.optionEnabled,
        optionValue: option.optionValue,
        type: option.optionType.type,
        isEditable: option.optionType.isEditable,
        isHidden: option.optionType.isHidden,
        isPremium: option.optionType.isPremium
      }

      const childrenId = []

      for (const children of option.optionType.children) {
        childrenId.push(children.id)
      }

      body.children = childrenId

      const parentId = []

      if (option.optionType.parent !== null) {
        parentId.push(option.optionType.parent.id)
      }

      body.parent = parentId

      const translations = {}

      for (const translation of option.optionType.translations) {
        translations[translation.language.languageTag] = translation.labelTranslation
      }

      body.translations = translations

      optionsTree[option.optionType.id] = body
    }

    return optionsTree
  }
)
